import React, { useEffect } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredMachines, selectMachineLoading, selectfetchMachineLoading } from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { deleteMachine } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const { MACHINE_ADD_EDIT } = MODAL_TYPES;

const MachineTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredMachines(state),
    isLoading: selectMachineLoading(state) || selectfetchMachineLoading(state),
  }));

  const handleEditClick = record => {
    dispatch(showModal(MACHINE_ADD_EDIT, record));
  };

  const handleDeleteClick = id => {
    dispatch(deleteMachine(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [
    {
      title: 'Asset Number',
      dataIndex: 'assetNumber',
      sorter: (a, b) => a.assetNumber.length - b.assetNumber.length,
    },
    {
      title: 'Cell Number',
      dataIndex: 'cellNumber',
      sorter: (a, b) => a.cellNumber.length - b.cellNumber.length,
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      sorter: (a, b) => a.brand.length - b.brand.length,
    },
    {
      title: 'Model Number',
      dataIndex: 'modelNumber',
      sorter: (a, b) => a.modelNumber.length - b.modelNumber.length,
    },
    {
      title: 'Tonnage',
      dataIndex: 'tonnage',
      sorter: (a, b) => a.tonnage.length - b.tonnage.length,
    },
    {
      title: 'Short Size (oz)',
      dataIndex: 'shotsize',
      sorter: (a, b) => a.shotsize.length - b.shotsize.length,
    },
    {
      title: 'Tie Bar Distance (Horizontal)',
      dataIndex: 'tieBarDistanceH',
      sorter: (a, b) => a.tieBarDistanceH.length - b.tieBarDistanceH.length,
    },
    {
      title: 'Tie Bar Distance (Vertical)',
      dataIndex: 'tieBarDistanceV',
      sorter: (a, b) => a.tieBarDistanceV.length - b.tieBarDistanceV.length,
    },
    {
      title: 'Mold Height Minimum',
      dataIndex: 'moldheightMin',
      sorter: (a, b) => a.moldheightMin.length - b.moldheightMin.length,
    },
    {
      title: 'Mold Height Maximum',
      dataIndex: 'moldheightMax',
      sorter: (a, b) => a.moldheightMax.length - b.moldheightMax.length,
    },
    {
      title: 'Serial Number',
      dataIndex: 'serialNumber',
      sorter: (a, b) => a.serialNumber.length - b.serialNumber.length,
    },
    {
      title: 'Number of Cores',
      dataIndex: 'numberofCores',
      sorter: (a, b) => a.numberofCores.length - b.numberofCores.length,
    },
    {
      title: 'Number of Valve Gates',
      dataIndex: 'numberofValveGates',
      sorter: (a, b) => a.numberofValveGates.length - b.numberofValveGates.length,
    },
    {
      title: 'Number of Air Blows',
      dataIndex: 'numberofAirBlows',
      sorter: (a, b) => a.numberofAirBlows.length - b.numberofAirBlows.length,
    },
    {
      title: 'Lane',
      dataIndex: 'lane',
      sorter: (a, b) => a.lane.length - b.lane.length,
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action justify-content-start">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive Machine-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default MachineTable;
